import React, { useEffect } from "react";
import { Checkbox, Tooltip } from '@material-ui/core';
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import MateDriveBreadcrumbs from "../Breadcrump/MateDriveBreadcrumbs";
import { useTranslation } from "react-i18next";
import { formatBytes } from "../../../../helpers/helper";


/**
 * @Description MateDrive File List design
 * @Param       data - folder data list
 * @Param       pathName - pathName
 * @Param       setSelectItem - func
 * @Param       selectItem - selected file or folder item
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function FileList({ data, pathName, setSelectItem, selectItem, selectFileItem, setSelectedItems, setSelectFileItem, selectedItems, isFileSelect, isFolderSelect, handleSelectFile, from, handleOnChange }) {
    const { t } = useTranslation();

    function handleClick(item, index) {
        setSelectItem(item);
        setSelectFileItem(item);
        // for (let i = 0; i < data.length; i++) {
        //     let elem = document.getElementById("mate-drive-file" + i);
        //     if (i === index) {
        //         if (elem !== undefined && elem !== null)
        //             elem.style = "background-color: var(--calypso) ; color:white";
        //     } else {
        //         if (elem !== undefined && elem !== null)
        //             elem.style = "background-color: transparent ; color:black";
        //     }
        // }
        // if (from) {
        handleSelectFile()
        // }
    }

    useEffect(() => {
        setSelectFileItem({})
    }, [data])

    const handleSelect = (e, item) => {
        if (e.target.checked) {
            setSelectedItems([...selectedItems, item]);
        }
        else {
            selectedItems.splice(selectedItems.indexOf(item), 1);
            setSelectedItems([...selectedItems]);
        }
    }

    return (
        <>
            <div>
                <MateDriveBreadcrumbs pathName={pathName} selectItem={selectItem} from={from} isFileSelect={isFileSelect} isFolderSelect={isFolderSelect} handleOnChange={handleOnChange} />
            </div>
            <div className="matedrive-breadcrumbs">
                <table>
                    <tr>
                        <th></th>
                        <th>{t("CONTENT.MATE-DRIVE.FILE-NAME")}</th>
                        <th>{t("CONTENT.MATE-DRIVE.MODIFIED-AT")}</th>
                        <th>{t("CONTENT.MATE-DRIVE.SIZE")}</th>
                    </tr>

                    {data &&
                        data.length > 0 &&
                        data.map(function (item, index) {
                            return (
                                <>
                                    {!item.is_dir ? (
                                        <tr
                                            key={index}
                                            id={"mate-drive-file" + index}
                                            style={{
                                                background: `${item.path === selectFileItem.path ? "var(--calypso)" : "transparent"}`,
                                                color: `${item.path === selectFileItem.path ? "white" : "black"}`
                                            }}
                                            onClick={() => handleClick(item, index)}
                                        >
                                            <td>
                                                <Checkbox color="default" size="small" checked={selectedItems?.length ? selectedItems.includes(item) : false}
                                                    onChange={(e) => handleSelect(e, item)} />
                                            </td>
                                            <td className="mate-drive-file-item-name-container">
                                                <InsertDriveFileOutlinedIcon
                                                    style={{ width: 18, height: 18 }}
                                                />
                                                <Tooltip title={item.name?.length > 30 ? item.name : ""} placement="top">
                                                    <span>{item.name}</span>
                                                </Tooltip>
                                            </td>
                                            <td>
                                                {new Date(item.mod_time).toLocaleString(
                                                    t("CONTENT.CREDENTIAL-TAB.LOCALE")
                                                )}
                                            </td>
                                            <td>{formatBytes(item.size, 2)}</td>
                                        </tr>
                                    ) : null}
                                </>
                            )
                        })}
                </table>
            </div>
        </>
    );
}
